class AdditionalDates {
    myFunction() {
        var row = document.getElementById("myRow");
        var x = row.insertCell(0);
            x.innerHTML = "New cell";
    }
}


// WEBPACK FOOTER //
// ./src/AdditionalDates.js